/**
 * SSE Refresh Manager
 * 
 * Invalidates React Query cache entries for the given endpoint names.
 * Called by sseEventHandler when an SSE event with type 'refresh' is received.
 * 
 * Uses the same predicate pattern as useFormActions.jsx:
 *   query.queryKey.some((part) => queryParams.includes(part))
 * 
 * This matches any query whose key contains the endpoint name as any part, covering:
 *   - ['list', endpoint, ...]  → list views (useListData)
 *   - [endpoint, id]           → card/detail views (PageView)
 *   - [endpoint, id, slug]     → card views with slug (e.g. ['creditNote', id, 'booked'])
 */

/**
 * Invalidate React Query cache for the specified endpoint names
 * @param {import('@tanstack/react-query').QueryClient} queryClient
 * @param {string[]} queryParams - Array of endpoint names to invalidate (e.g. ['creditNote'])
 */
const invalidate = (queryClient, queryParams) => {
    if (!queryClient || !queryParams?.length) return;

    queryClient.invalidateQueries({
        predicate: (query) =>
            query.queryKey.some((part) =>
                typeof part === 'string' &&
                queryParams.some(p => part === p || part.startsWith(`${p}/`))
            )
    });

    console.log(`[SSE RefreshManager] Invalidated queries for: [${queryParams.join(', ')}]`);
};

export const refreshManager = { invalidate };
